import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as PaperEdit } from '../../assets/images/svg/paper-edit.svg';
import themeColors from '../../assets/styles/themeColors';

const PaperEditStyled = styled(PaperEdit)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundSecondaryLight};
  stroke: ${themeColors.colorTextPrimary};

  circle {
    stroke: none;
  }
`;

const PaperEditIcon = (props) => <PaperEditStyled {...props} />;

PaperEditIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

PaperEditIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default PaperEditIcon;
